if (!customElements.get('yc-artisan-carousel')) {
  class YcArtisanCarousel extends HTMLElement {
    connectedCallback() {
      this.initCarousel();
    }

    initCarousel() {
      const navItems = this.querySelectorAll('.yc-artisan-carousel__nav-item');
      const slides = this.querySelectorAll('.yc-artisan-carousel__slide');
      const track = this.querySelector('.yc-artisan-carousel__track');
      
      if (navItems.length === 0 || slides.length === 0) return;

      const isAutoplay = this.dataset.autoplay === 'true';
      const intervalTime = parseInt(this.dataset.interval) || 5000;
      let autoplayTimer = null;
      let currentIndex = 0;
      let touchStartX = 0;
      let touchStartY = 0;

      const navWrapper = this.querySelector('.yc-artisan-carousel__nav-wrapper');

      const goToSlide = (index) => {
        navItems.forEach(n => n.classList.remove('is-active'));
        slides.forEach(s => s.classList.remove('is-active'));
        
        navItems[index].classList.add('is-active');
        slides[index].classList.add('is-active');
        
        if (navWrapper) {
          const navItem = navItems[index];
          const scrollLeft = navItem.offsetLeft - (navWrapper.clientWidth / 2) + (navItem.clientWidth / 2);
          navWrapper.scrollTo({ left: scrollLeft, behavior: 'smooth' });
        }
        
        currentIndex = index;
      };

      const startAutoplay = () => {
        if (!isAutoplay) return;
        stopAutoplay();
        autoplayTimer = setInterval(() => {
          let nextIndex = (currentIndex + 1) % slides.length;
          goToSlide(nextIndex);
        }, intervalTime);
      };

      const stopAutoplay = () => {
        if (autoplayTimer) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      };

      navItems.forEach((navItem, index) => {
        navItem.addEventListener('click', () => {
          goToSlide(index);
          startAutoplay();
        });
      });

      if (track) {
        track.addEventListener('touchstart', (event) => {
          const touch = event.changedTouches[0];
          if (!touch) return;

          stopAutoplay();
          touchStartX = touch.screenX;
          touchStartY = touch.screenY;
        }, { passive: true });

        track.addEventListener('touchend', (event) => {
          const touch = event.changedTouches[0];
          const swipeThreshold = 50;
          let deltaX;
          let deltaY;

          if (!touch) {
            startAutoplay();
            return;
          }

          deltaX = touch.screenX - touchStartX;
          deltaY = touch.screenY - touchStartY;

          if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > swipeThreshold) {
            if (deltaX < 0) {
              goToSlide((currentIndex + 1) % slides.length);
            } else {
              goToSlide((currentIndex - 1 + slides.length) % slides.length);
            }
          }

          startAutoplay();
        }, { passive: true });
      }

      this.addEventListener('mouseenter', stopAutoplay);
      this.addEventListener('mouseleave', startAutoplay);

      startAutoplay();
    }
  }
  customElements.define('yc-artisan-carousel', YcArtisanCarousel);
}
